<template>
	<div class="topBar">
		<img class="logImg" src="../assets/logo.png" alt="">
		<div class="headerBox" v-if="isShow" @click="naviToHome">首页</div>
		<div class="searchBox"
			:class="isFocus ? 'searchFocusSearchBox' : hoverHot ? 'searchHoverSearchBox' : 'searchBlurSearchBox'"
			:style="{'left': !isShow ? '158px' : '214px'}">
			<div class="searchInputBox">
				<span class="searchIcon iconfont">&#xe63c;</span>
				<input class="inputBox" type="text" placeholder="热门搜索" @focus="searchInputFocus"
					@blur="searchInputBlur" v-model="keyWord">
			</div>
			<div class="searchHotBox" :class="hoverHot && !isFocus ? 'hoverColor' : 'noHoverColor'"
				@mouseenter="hotMouseEnter" @mouseleave="hotMouseLeave">
				<span class="searchIcon iconfont">&#xe7a3;</span>
				<div class="hotTitle">热搜榜</div>
			</div>
			<div class="searchFocusButton" :style="{'display': isFocus ? 'inline-block' : 'none'}"
				@click="naviToHotDetails">
				<img src="//img.alicdn.com/imgextra/i2/O1CN01TTI7vI1GYPt7FowfZ_!!6000000000634-2-tps-200-200.png">
			</div>
		</div>
		<div class="rightBox">
			<img class="cfnImg" src="../assets/cfn.png" alt="">
			中国金融视频影像中心
		</div>
		<div class="searchSearchList" @mouseenter="hotMouseEnter" @mouseleave="hotMouseLeave" :style="{'left': !isShow ? '160px' : '214px'}"
			v-if="isFocus || hoverHot">
			<div class="listMenuTitle">
				热门搜索
			</div>
			<div class="listBox">
				<div class="listItem" @mouseenter="hoverIndex = index" @mouseleave="hoverIndex = -1"
					v-for="(item,index) in hotDatas" :key="index" v-if="index < 5" @click="naviToDetails(item.VId)">
					<div class="listNumBox">
						<div class="listNumOneBox"
							:class="index == 0 ? 'listTopOne' : index == 1 ? 'listTopTwo' : index == 2 ? 'listTopThree' : 'listTopFour'">
							<span class="listNumTexgBox">{{index + 1}}</span>
						</div>
					</div>
					<div class="listItemNoHoverNormal listItemNoHoverBox"
						:style="{'display':  hoverIndex != index ? 'flex' : 'none'}">
						<div class="listItemNameBox">{{item.Title}}</div>
						<div class="listItemTipBox">&nbsp;·&nbsp;播放量<span class="listItemIndexBox">{{item.Clicks}}</span>
						</div>
					</div>
					<div class="listItemHoverNormal listItemHoverBox"
						:style="{'display':  hoverIndex == index ? 'block' : 'none'}">
						<img class="listItemImg" :src="item.CoverUrlPortrait" alt="">
						<div class="listItemHoverNormalContent">
							<div class="listItemHoverNormalContentRight">
								<div class="listItemNameBox">{{item.Title}}</div>
								<div class="listItemTipBox">&nbsp;·&nbsp;播放量<span
										class="listItemIndexBox">{{item.Clicks}}</span>
								</div>
							</div>
							<div class=" listitemOtherTips">{{item.UpdateDate}}</div>
							<div class="listitemOtherTips">{{item.Intro}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import "../assets/iconfont.css"
	export default {
		name: 'topMenu',
		props: {
			isShow: {
				type: Boolean,
				default: false,
			}
		},
		data() {
			return {
				keyWord: '',
				inputTimer: null,
				hoverTimer: null,
				isFocus: false,
				hoverIndex: -1,
				hoverHot: false,
				hotDatas: [],
			}
		},
		mounted() {
			this.getVlogVideoList()
		},
		methods: {
			//推荐视频列表
			getVlogVideoList() {
				this.$api.post('/VideoNew/getVlogVideoList', {
					Tid: '0',
					order: 'Clicks DESC'
				}).then(res => {
					if (res.code == 200) {
						this.hotDatas = res.data.data
					}
				}).catch(err => {
					console.log(err);
				})
			},
			searchInputFocus(event) {
				clearTimeout(this.inputTimer)
				this.isFocus = true
			},
			searchInputBlur(event) {
				let that = this
				this.inputTimer = setTimeout(() => {
					that.isFocus = false
				}, 200)
			},
			hotMouseEnter(event) {
				clearTimeout(this.hoverTimer)
				this.hoverHot = true
			},
			hotMouseLeave(event) {
				let that = this
				this.hoverTimer = setTimeout(() => {
					that.hoverHot = false
				}, 200)
			},
			naviToHotDetails() {
				// this.$router.push({
				// 	name: 'Search',
				// 	params: {
				// 		keyWord: this.keyWord
				// 	}
				// });
				let routeData = this.$router.resolve({ path: '/Search',query: {keyWord: this.keyWord}});
				window.open(routeData.href, '_blank');
				this.keyWord = ''
			},
			naviToDetails(videoId){
				let routeData = this.$router.resolve({ path: '/Details',query: {videoId: videoId}});
				window.open(routeData.href, '_blank');
			},
			naviToHome(){
				window.open('/')
			}
		}
	}
</script>

<style lang="scss" scoped>
	.topBar {
		position: fixed;
		top: 0px;
		left: 0px;
		width: 100%;
		height: 70px;
		background: #16161A;
		display: flex;
		align-items: center;
		z-index: 99;

		.logImg {
			width: 98px;
			height: 22px;
			margin-left: 26px;
		}

		.headerBox {
			margin-left: 24px;
			font-size: 18px;
			font-weight: 400;
			color: #FFFFFF;
			cursor: pointer;
		}

		.headerBox:hover {
			color: #61f6ff;
		}

		.rightBox {
			position: absolute;
			right: 40px;
			display: flex;
			align-items: center;
			font-size: 20px;
			font-weight: 500;
			color: #FAF7F7;

			.cfnImg {
				width: 30px;
				height: 40px;
				margin-right: 10px;
			}
		}

		.searchBox {
			width: 465px;
			height: 40px;
			border-radius: 10px;
			position: absolute;
			top: 14px;
			text-align: left;
			-webkit-app-region: no-drag;

			.searchInputBox {
				height: 40px;
				float: left;
				text-align: left;
				background-color: initial;
				position: relative;
				padding-left: 36px;
				line-height: 40px;

				.inputBox {
					border: 0px;
					height: 20px;
					outline: 0 none;
					caret-color: hsla(0, 0%, 100%, .6);
					color: hsla(0, 0%, 100%, .6);
					font-size: 16px;
					font-weight: 400;
					box-sizing: border-box !important;
					background-color: transparent;
					margin-right: 9px;
					padding-right: 32px;
					margin-top: 10px
				}

				.searchIcon {
					display: inline-block;
					width: 20px;
					height: 20px;
					position: absolute;
					font-size: 20px;
					color: hsla(0, 0%, 100%, .5);
					top: 50%;
					-webkit-transform: translateY(-50%);
					transform: translateY(-50%);
					left: 12px;
					line-height: 20px;
				}
			}

			.searchHotBox {
				float: left;
				width: 76px;
				height: 40px;
				line-height: 40px;
				font-size: 16px;
				line-height: 20px;
				font-weight: 400;
				display: flex;
				align-items: center;
				cursor: pointer;
			}

			.noHoverColor {
				color: hsla(0, 0%, 100%, .5);
			}

			.hoverColor {
				color: #61f6ff;
			}

			.searchHotBox:hover {
				color: #61f6ff;
			}

			.searchFocusButton {
				display: inline-block;
				width: 43px;
				height: 42px;
				background-color: #4ae3fa;
				color: #000;
				line-height: 42px;
				text-align: center;
				border-radius: 0 10px 10px 0;
				position: relative;
				top: -1px;
				right: -1px
			}

			.searchFocusButton img {
				width: 20px;
				height: 20px;
				display: block;
				position: absolute;
				left: 0;
				top: 0;
				right: 0;
				bottom: 0;
				margin: auto
			}

			.searchFocusButton:hover {
				cursor: pointer
			}

		}

		.searchFocusSearchBox {
			border: 1px solid #4ae3fa;
			background-color: rgba(0, 0, 0, .9);

			.searchInputBox {
				width: 310px;

				.inputBox {
					width: 292px;
				}
			}
		}

		.searchBlurSearchBox {
			background-color: rgba(0, 0, 0, .2);
			border: 1px solid hsla(0, 0%, 100%, .2);

			.searchInputBox {
				width: 353px;

				.inputBox {
					width: 335px;
				}
			}
		}

		.searchHoverSearchBox {
			background-color: rgba(0, 0, 0, .9);
			border: 1px solid hsla(0, 0%, 100%, .0);

			.searchInputBox {
				width: 353px;

				.inputBox {
					width: 335px;
				}
			}
		}

		.searchSearchList {
			position: absolute;
			top: 64px;
			// left: 160px;
			width: 465px;
			border-radius: 10px;
			padding-bottom: 10px;
			background-color: rgba(0, 0, 0, .9);
			z-index: 1;

			.listMenuTitle {
				height: 28px;
				color: #fff;
				font-weight: 600;
				font-size: 16px;
				line-height: 26px;
				margin-top: 16px;
				padding-left: 15px;
			}

			.listBox {
				margin-top: 10px;

				.listItem {
					height: 46px;
					font-size: 16px;
					color: #eaeaea;
					position: relative;
					font-weight: 400;
					padding-left: 50px;
					padding-right: 25px;
					cursor: pointer;

					.listNumBox {
						width: 23px;
						height: 20px;
						position: absolute;
						left: 15px;
						top: 50%;
						-webkit-transform: translateY(-50%);
						transform: translateY(-50%);

						.listNumOneBox {
							position: absolute;
							left: 0;
							top: 50%;
							text-align: left;
							width: 16px;
							height: 17px;
							transform: skew(-18deg) translateY(-50%);
							-webkit-transform: skew(-18deg) translateY(-50%);
							-moz-transform: skew(-18deg) translateY(-50%);
							-o-transform: skew(-18deg) translateY(-50%);
							-ms-transform: skew(-18deg) translateY(-50%);

							.listNumTexgBox {
								width: 23px;
								height: 20px;
								line-height: 20px;
								position: absolute;
								left: 0;
								top: 0;
								font-size: 19px;
								transform: skew(18deg);
								-webkit-transform: skew(18deg);
								-moz-transform: skew(18deg);
								-o-transform: skew(18deg);
								-ms-transform: skew(18deg);
								font-weight: 900;
							}
						}

						.listTopOne {
							background-color: rgba(255, 124, 249, .2);
							color: #ff008c;
						}

						.listTopTwo {
							background-color: rgba(255, 149, 124, .2);
							color: #ff4f34;
						}

						.listTopThree {
							background-color: rgba(255, 177, 18, .22);
							color: #ff9100;
						}

						.listTopFour {
							background-color: hsla(0, 0%, 80%, .2);
							color: #ccc;
						}
					}


					.listItemNoHoverBox {
						display: flex;
						align-items: center;
						height: 100%;
					}

					.listItemNoHoverNormal {
						display: flex;
						align-items: center;

						.listItemNameBox {
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap
						}

						.listItemTipBox {
							flex: 1 1;
							white-space: nowrap;
							font-size: 12px;
							color: hsla(0, 0%, 100%, .6);

							.listItemIndexBox {
								font-size: 13px;
								color: #ff33a3;
								margin-left: 3px;
							}
						}
					}

					.listItemHoverBox {
						display: none;
						padding: 14px 0 14px 55px;
						position: relative;
						height: 61px;
					}

					.listItemHoverNormal {

						.listItemImg {
							position: absolute;
							border-radius: 4px;
							top: 14px;
							left: 0;
							width: 46px;
							height: 61px;
							// background-position: 50%;
							// background-repeat: no-repeat;
							// background-size: cover;
						}

						.listItemHoverNormalContent {
							line-height: 20px;
							height: 100%;
							display: flex;
							flex-direction: column;

							.listItemHoverNormalContentRight {
								display: flex;
								align-items: center;

								.listItemNameBox {
									overflow: hidden;
									text-overflow: ellipsis;
									white-space: nowrap
								}

								.listItemTipBox {
									flex: 1 1;
									white-space: nowrap;
									font-size: 12px;
									color: hsla(0, 0%, 100%, .6);

									.listItemIndexBox {
										font-size: 13px;
										color: #ff33a3;
										margin-left: 3px
									}
								}
							}

							.listitemOtherTips {
								font-size: 12px;
								color: hsla(0, 0%, 100%, .6);
								overflow: hidden;
								text-overflow: ellipsis;
								white-space: nowrap;
							}
						}
					}
				}

				.listItem:hover {
					height: 89px;
					background-color: hsla(0, 0%, 100%, .06)
				}
			}
		}
	}
</style>